// TODO - Type 'any' needs to be fixed.
/* eslint-disable no-mixed-spaces-and-tabs */
import AddIcon from "@mui/icons-material/Add";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import RemoveIcon from "@mui/icons-material/Remove";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import {
	Autocomplete,
	Checkbox,
	CircularProgress,
	IconButton,
	InputAdornment,
	Select,
	TextField as Text,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
//import GigandTakeSwitch from "@gigandtake/switch";
// import { Button, IconButton } from "@mui/material";
// import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Snackbar from "@mui/material/Snackbar";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
// import format from "date-fns/format";
import {
	DateTimePicker,
	LocalizationProvider,
} from "@mui/x-date-pickers-pro-6";
import { AdapterDayjs } from "@mui/x-date-pickers-pro-6/AdapterDayjs";
import { differenceInHours, differenceInMinutes, format } from "date-fns";
import dayjs from "dayjs";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-mui";
import React, { ReactNode, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

// import Toggle from "../../../../../design/toggle";
import {
	editDraftShift,
	resetEditDraftShift,
} from "../../../../../../export/shift-scheduler";
import { resetMaxWorkersByLocationJob } from "../../../../../components/jobs/store/jobs-slice";
// import DateTimePicker from "../../../../../design/date-time-picker/date-time-picker";
import CutoffHoursInput from "../../../../../design/cutoff-hours-input";
import Toggle from "../../../../../design/toggle";
import JobColor from "../../../../../design/ui/job-color";
import {
	DEFAULT_CUTOFF_HOURS,
	formatCutoffHours,
	getAcceptanceCutoffTime,
} from "../../../../../utils/acceptance-cutoff";
import { useDateFnsLocale } from "../../../../../utils/date-locale";
import { getShiftPurposeDetailField } from "../../../../../utils/shift-purpose-detail-field";
import useViewport from "../../../../../utils/use-viewport";
import { Location, SchedulerWorkCenter } from "../../../../scheduler/store/types";
import useSchedulerData from "../../../controllers/use-scheduler-data";
import SelectSkills from "../create-new-shift-dialog/select-skills";
import useEditShiftDialog from "./controllers/use-edit-shift-dialog";
import { useEditShiftDialogForm } from "./controllers/use-edit-shift-dialog-form";
import EditActionButtons from "./edit-action-buttons";
import EndTimePicker from "./end-time-picker";
import { setToNearestTime, useStyles } from "./utils";

interface FilledFormControlProps {
	children: ReactNode;
	customStyles?: Record<string, string | number>;
}

const scrollBarStyles = {
	height: "100%",
	maxHeight: "65vh",
	width: "100%",
	overflowY: "auto",
	overflowX: "hidden",
	padding: "0px 45px",
	"&::-webkit-scrollbar": {
		width: "8px",
	},
	"&::-webkit-scrollbar-track": {
		background: "#f1f1f1",
	},
	"&::-webkit-scrollbar-thumb": {
		background: "#888",
		borderRadius: "4px",
	},
	"&::-webkit-scrollbar-thumb:hover": {
		background: "#555",
	},
	"&::-webkit-scrollbar-corner": {
		background: "transparent",
	},
	"&::-webkit-resizer": {
		background: "transparent",
	},
	"&::-webkit-scrollbar-button": {
		display: "none",
	},
};

const FilledFormControl: React.FC<FilledFormControlProps> = ({
	children,
	customStyles,
}) => {
	const classes = useStyles();
	return (
		<FormControl
			variant='filled'
			className={classes.formControlRoot}
			sx={{ 
        ...customStyles,
        "& .MuiFormHelperText-root": {
          whiteSpace: "normal",
          wordBreak: "break-word",
        }
      }}
		>
			{children}
		</FormControl>
	);
};

type EditShiftDialogFormProps = {
	dispatchLocal: (arg0: any) => void;
	dispatchLocalSkill: (arg0: any) => void;
	state: any;
	skillState: any;
	handleClose: (() => void) | undefined;
};

const EditShiftDialogForm: React.FC<EditShiftDialogFormProps> = ({
	dispatchLocal,
	dispatchLocalSkill,
	state,
	skillState,
	handleClose,
}) => {
	const classes = useStyles();
	const { t } = useTranslation();
	const dateLocale = useDateFnsLocale();
	const { width } = useViewport();
	const dispatch = useDispatch();

	const [shiftType, setShiftType] = React.useState("jobs");

	const [
		{
			initialValues,
			schema,
			initialShiftDateTimeValues,
			filteredJobs,
			//selectedDatesOfTheWeek,
			totalHours,
			totalMins,
			shiftId,
		},
		{
			//isDisabled,
			calculateTotalHoursFromEndTime,
			calculateTotalHoursFromStartTime,
			calculateTotalHoursFromWorkers,
			handleWorkcenterChange,
			getNumberOfStaff,
			setInitialShiftDateTimeValue,
			setSelectedDatesOfTheWeek,
			setTotalHours,
		},
	] = useEditShiftDialog();

	const [
		,
		{
			onFormSubmit,
			onEndTimeChange,
			onStartTimeChange,
			getLocationWorkcenters,
		},
	] = useEditShiftDialogForm({
		state,
		skillState,
		setToNearestTime,
		dispatch,
		dispatchLocal,
		dispatchLocalSkill,
		editDraftShift,
		calculateTotalHoursFromStartTime,
		calculateTotalHoursFromEndTime,
	});

	const {
		maxWorkersByJobLocation,
		fetchFilterAndShiftDataStatus,
		workcenters,
		filterAllWorkcenters,
		isShiftBySkillEnabled,
		shiftPurposes,
		isShiftPurposeEnabled,
		editDraftShiftStatus,
		editDraftShiftErrorMessage,
		filterAllLocations,
		defaultShiftsSkillLevel,
		allSkillLevels,
		shiftWorkerTypeFilterEnabled,
		workerTypesForCreateShift: workerTypes,
		urgentShiftEnabledLocations,
	} = useSchedulerData();
	// For the toolip for Shift By Skill
	const skillLevel = allSkillLevels.find(
		(s: any) => s.level === defaultShiftsSkillLevel
	);
	const levelName = skillLevel ? skillLevel.name : t("common_not-applicable");

	const locationWorkcenters =
		getLocationWorkcenters && getLocationWorkcenters(workcenters);

	useEffect(() => {
		const newInitialValues = initialValues;
		newInitialValues.startTime = setToNearestTime(initialValues.startTime);
		newInitialValues.endTime = setToNearestTime(initialValues.endTime);
		if (fetchFilterAndShiftDataStatus === "fulfilled") {
			const locationWorkcenter = filterAllWorkcenters?.find(
				(workcenter: SchedulerWorkCenter) =>
					workcenter.id === parseInt(initialValues.shiftData.workCenterId)
			);
			newInitialValues.locationId = locationWorkcenter?.locationId;
		}
		setInitialShiftDateTimeValue &&
			setInitialShiftDateTimeValue(newInitialValues);
		setShiftType(initialValues.jobId ? "jobs" : "skills");
	}, [
		fetchFilterAndShiftDataStatus,
		filterAllWorkcenters,
		initialValues,
		setInitialShiftDateTimeValue,
	]);

	return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Formik
        key={`edit-shift-${initialShiftDateTimeValues.locationId}`}
        initialValues={initialShiftDateTimeValues}
        validationSchema={schema}
        onSubmit={(values, actions) => {
          if (onFormSubmit) onFormSubmit(values, actions);
        }}
      >
        {({
          isValid,
          dirty,
          values,
          setFieldValue,
          setValues,
          isSubmitting,
          validateForm,
          errors,
        }) => {
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const prevWorkCenterIdRef = useRef(values.workCenterId);

          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            if (prevWorkCenterIdRef.current !== values.workCenterId) {
              setFieldValue("isFlexiSignupEnabled", false);
              setFieldValue("allowPartialSignups", false);
              setFieldValue("minFlexiSignupHours", 1);
              prevWorkCenterIdRef.current = values.workCenterId;
            }
          }, [values.workCenterId, setFieldValue]);

          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            if (values.workCenterId && filterAllWorkcenters) {
              const selectedWorkcenter = filterAllWorkcenters.find(
                (wc: SchedulerWorkCenter) => wc.id === values.workCenterId
              );
              if (selectedWorkcenter) {
                const isFlexiSupported =
                  !!selectedWorkcenter.isFlexiSignupEnabled;
                const isPartialSupported =
                  !!selectedWorkcenter.isPartialSignupEnabled;

                if (values.isFlexiSignupEnabled && !isFlexiSupported) {
                  setFieldValue("isFlexiSignupEnabled", false);
                }
                if (values.allowPartialSignups && !isPartialSupported) {
                  setFieldValue("allowPartialSignups", false);
                }
              }
            }
          }, [
            values.workCenterId,
            values.isFlexiSignupEnabled,
            values.allowPartialSignups,
            setFieldValue,
          ]);

          // Free-text detail the selected Shift Purpose asks for, configured
          // per Shift Purpose in GAT Admin.
          const shiftPurposeDetailField = getShiftPurposeDetailField(
            shiftPurposes,
            values.shiftPurposeId
          );

          return (
            <Form className={classes.formRoot}>
              <Box sx={scrollBarStyles} mt={0}>
                {!isShiftPurposeEnabled ? null : (
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    flexDirection={width < 600 ? "column" : "row"}
                  >
                    <Box width={"100%"}>
                      <FilledFormControl>
                        <Field
                          component={TextField}
                          type="text"
                          select
                          variant="filled"
                          name="shiftPurposeId"
                          id="shiftPurposeId"
                          label={t("scheduler_shift-purpose")}
                          disabled={values.shiftPublished}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setFieldValue("shiftPurposeId", e.target.value);
                            setFieldValue("shiftPurposeDetail", "");
                          }}
                          helperText=" "
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // Ensure the label shrinks properly
                          }}
                          SelectProps={{
                            displayEmpty: true,
                            renderValue: (value: any) => {
                              // Show placeholder if value is 0 or falsy
                              if (!value) {
                                return (
                                  <Typography
                                    sx={{
                                      fontFamily: "Roboto",
                                      fontSize: "16px",
                                      color: "rgba(0, 0, 0, 0.6)",
                                    }}
                                  >
                                    {t("scheduler_select-a-purpose")}
                                  </Typography>
                                );
                              }
                              // Otherwise, display the selected value's name
                              const selectedPurpose = shiftPurposes?.[value];
                              return selectedPurpose
                                ? selectedPurpose.name
                                : "";
                            },
                          }}
                        >
                          {/* Render active shift purposes, plus the one
											currently selected on this shift even if it is
											now inactive, so the selection is not dropped */}
                          {shiftPurposes &&
                            Object.values(shiftPurposes)
                              .filter(
                                (purpose: any) =>
                                  purpose.isActive ||
                                  purpose.id === values.shiftPurposeId
                              )
                              .map((purpose: any) => (
                                <MenuItem
                                  value={purpose.id}
                                  key={`shift-purpose-${purpose.id}`}
                                >
                                  {purpose.name}
                                </MenuItem>
                              ))}
                        </Field>
                      </FilledFormControl>
                      {shiftPurposeDetailField ? (
                        <>
                          <FilledFormControl>
                            <Field
                              component={TextField}
                              type="text"
                              variant="filled"
                              multiline
                              rows={2}
                              name="shiftPurposeDetail"
                              id="shiftPurposeDetail"
                              label={shiftPurposeDetailField.label}
                              required={shiftPurposeDetailField.isRequired}
                              disabled={values.shiftPublished || isSubmitting}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{
                                maxLength: shiftPurposeDetailField.maxLength,
                              }}
                              fullWidth
                            />
                          </FilledFormControl>
                          <Box display="flex" justifyContent="flex-end">
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: "400",
                                lineHeight: "19px",
                                fontFamily: "Roboto",
                                color: "#666666",
                              }}
                            >{`${(values.shiftPurposeDetail ?? "").length} / ${shiftPurposeDetailField.maxLength}`}</Typography>
                          </Box>
                        </>
                      ) : null}
                    </Box>
                  </Box>
                )}

                <Box
                  display="flex"
                  justifyContent="space-between"
                  flexDirection={width < 600 ? "column" : "row"}
                  mb={1}
                >
                  <Box width={width < 600 ? "100%" : "48%"} mb={2} mr={1}>
                    {/*<DateTimePicker*/}
                    {/*	label='Shift Start Time'*/}
                    {/*	value={values.startTime}*/}
                    {/*	disabled={values.shiftPublished}*/}
                    {/*	onChange={(newValue) => {*/}
                    {/*		if (onStartTimeChange && getNumberOfStaff) {*/}
                    {/*			const formattedDate =*/}
                    {/*				dayjs(newValue).format("YYYY-MM-DDTHH:mm");*/}
                    {/*			onStartTimeChange(formattedDate, {*/}
                    {/*				setFieldValue,*/}
                    {/*				values,*/}
                    {/*			});*/}
                    {/*			getNumberOfStaff(*/}
                    {/*				values.jobId,*/}
                    {/*				values.locationId,*/}
                    {/*				values.workCenterId,*/}
                    {/*				new Date(formattedDate).toISOString(),*/}
                    {/*				new Date(values.endTime).toISOString(),*/}
                    {/*				values.shiftSkills,*/}
                    {/*				values.allowPartialSignups*/}
                    {/*			);*/}
                    {/*		}*/}
                    {/*	}}*/}
                    {/*	isError={errors.startTime ? true : false}*/}
                    {/*	helperText={errors.startTime?.toString() || ""}*/}
                    {/*/>*/}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        label={t("scheduler_shift-start-time")}
                        disabled={values.shiftPublished}
                        value={
                          values.startTime
                            ? dayjs(values.startTime, "YYYY-MM-DDTHH:mm")
                            : null
                        }
                        format="MM/DD/YYYY, hh:mm A"
                        onChange={(newValue: any) => {
                          if (onStartTimeChange && getNumberOfStaff) {
                            const formattedDate =
                              dayjs(newValue).format("YYYY-MM-DDTHH:mm");
                            onStartTimeChange(formattedDate, {
                              setFieldValue,
                              setValues,
                              values,
                            });
                            getNumberOfStaff(
                              values.jobId,
                              values.locationId,
                              values.workCenterId,
                              new Date(formattedDate).toISOString(),
                              new Date(values.endTime).toISOString(),
                              values.shiftSkills,
                              values.allowPartialSignups,
                              values.allowedWorkerTypeIds
                            );
                          }
                        }}
                        slotProps={{
                          textField: {
                            variant: "filled",
                            fullWidth: true,
                            InputLabelProps: {
                              shrink: true,
                            },
                            error: !!errors.startTime,
                            helperText: <>{errors.startTime ?? ""}</>,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                  <Box width={width < 600 ? "100%" : "48%"}>
                    {/*<EndTimePicker*/}
                    {/*	minShiftHourDuration={minShiftHourDuration}*/}
                    {/*	maxShiftHourDuration={maxShiftHourDuration}*/}
                    {/*	defaultShiftHourDuration={differenceInMinutes(*/}
                    {/*		new Date(values.endTime),*/}
                    {/*		new Date(values.startTime)*/}
                    {/*	)}*/}
                    {/*	values={values}*/}
                    {/*	startDateTime={values.startTime}*/}
                    {/*	setFieldValue={setFieldValue}*/}
                    {/*	onChange={(newValue: string) => {*/}
                    {/*		const formattedDate =*/}
                    {/*			dayjs(newValue).format("YYYY-MM-DDTHH:mm");*/}
                    {/*		const formattedDateObj = new Date(formattedDate);*/}
                    {/*		const startTimeObj = new Date(values.startTime);*/}

                    {/*		if (onEndTimeChange && getNumberOfStaff) {*/}
                    {/*			onEndTimeChange(formattedDate, { setFieldValue, values });*/}
                    {/*			getNumberOfStaff(*/}
                    {/*				values.jobId,*/}
                    {/*				values.locationId,*/}
                    {/*				values.workCenterId,*/}
                    {/*				startTimeObj.toISOString(),*/}
                    {/*				formattedDateObj.toISOString(),*/}
                    {/*				values.shiftSkills,*/}
                    {/*				values.allowPartialSignups*/}
                    {/*			);*/}
                    {/*		}*/}

                    {/*		if (values.allowPartialSignups && values.locationId) {*/}
                    {/*			const selectedLocation = filterAllLocations?.find(*/}
                    {/*				(location: {*/}
                    {/*					id: number;*/}
                    {/*					partialShiftMinHours: number;*/}
                    {/*				}) => location.id === Number(values.locationId)*/}
                    {/*			);*/}

                    {/*			const shiftDuration = differenceInHours(*/}
                    {/*				formattedDateObj,*/}
                    {/*				startTimeObj*/}
                    {/*			);*/}

                    {/*			if (*/}
                    {/*				shiftDuration < selectedLocation?.partialShiftMinHours*/}
                    {/*			) {*/}
                    {/*				setFieldValue("allowPartialSignups", false);*/}
                    {/*			}*/}
                    {/*		}*/}
                    {/*	}}*/}
                    {/*	errors={errors}*/}
                    {/*	disabled={values.shiftPublished}*/}
                    {/*/>*/}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        label={t("scheduler_shift-end-time")}
                        disabled={values.shiftPublished}
                        value={
                          values.endTime
                            ? dayjs(values.endTime, "YYYY-MM-DDTHH:mm")
                            : null
                        }
                        format="MM/DD/YYYY, hh:mm A"
                        onChange={(newValue: any) => {
                          const formattedDate =
                            dayjs(newValue).format("YYYY-MM-DDTHH:mm");
                          const formattedDateObj = new Date(formattedDate);
                          const startTimeObj = new Date(values.startTime);

                          if (onEndTimeChange && getNumberOfStaff) {
                            onEndTimeChange(formattedDate, {
                              setFieldValue,
                              setValues,
                              values,
                            });
                            getNumberOfStaff(
                              values.jobId,
                              values.locationId,
                              values.workCenterId,
                              startTimeObj.toISOString(),
                              formattedDateObj.toISOString(),
                              values.shiftSkills,
                              values.allowPartialSignups,
                              values.allowedWorkerTypeIds
                            );
                          }
                        }}
                        slotProps={{
                          textField: {
                            variant: "filled",
                            fullWidth: true,
                            InputLabelProps: {
                              shrink: true,
                            },
                            error: !!errors.endTime,
                            helperText: <>{errors.endTime ?? ""}</>,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>

                <Box width={"100%"}>
                  <FilledFormControl>
                    <Field
                      component={TextField}
                      type="text"
                      select
                      variant="filled"
                      name="workCenterId"
                      id="workCenterId"
                      label={t("scheduler_location-work-center")}
                      disabled={values.shiftPublished}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (handleWorkcenterChange) {
                          setFieldValue("workCenterId", e.target.value);
                          handleWorkcenterChange(e.target.value);
                          let locationWorkcenter = locationWorkcenters?.find(
                            (lwc: any) =>
                              lwc.id.toString() ===
                              values?.workCenterId?.toString()
                          );
                          if (fetchFilterAndShiftDataStatus === "fulfilled") {
                            locationWorkcenter = filterAllWorkcenters?.find(
                              (workcenter: SchedulerWorkCenter) =>
                                workcenter.id === parseInt(e.target.value)
                            );
                          }
                          setFieldValue(
                            "locationId",
                            locationWorkcenter?.locationId
                          );
                          setFieldValue("jobId", "");
                          setFieldValue("hexColor", "");
                        }
                        if (values.allowPartialSignups && values.locationId) {
                          const selectedLocation = filterAllLocations?.find(
                            (location: { id: number }) =>
                              location.id === Number(values.locationId)
                          );
                          if (!selectedLocation?.isPartialSignupEnabled) {
                            setFieldValue("allowPartialSignups", false);
                          }
                        }
                      }}
                      helperText=" "
                    >
                      {fetchFilterAndShiftDataStatus === "fulfilled" &&
                        filterAllWorkcenters &&
                        filterAllWorkcenters.map(
                          (workcenter: SchedulerWorkCenter) => (
                            <MenuItem
                              value={`${workcenter.id}`}
                              key={`workcenter-${workcenter.id}`}
                              id={`${workcenter.id}`}
                            >
                              {workcenter.nameWithLocation}
                            </MenuItem>
                          )
                        )}
                      {fetchFilterAndShiftDataStatus !== "fulfilled" &&
                        locationWorkcenters &&
                        locationWorkcenters.map((lwc: any) => (
                          <MenuItem value={lwc.id} key={lwc.id} id={lwc.id}>
                            {lwc.locationName} - {lwc.name}
                          </MenuItem>
                        ))}
                    </Field>
                  </FilledFormControl>
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  flexDirection={width < 600 ? "column" : "row"}
                  mb={3}
                >
                  <Box width={width < 600 ? "100%" : "48%"} mr={1}>
                    <FilledFormControl>
                      <Field
                        component={TextField}
                        type="text"
                        variant="filled"
                        name="numberOfWorkersNeeded"
                        id="numberOfWorkersNeeded"
                        label={t("scheduler_required-workers")}
                        disabled={isSubmitting}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          const rawValue = e.target.value;
                          // Only allow empty or digits (no decimals, no negatives)
                          if (rawValue === "" || /^[0-9]+$/.test(rawValue)) {
                            setFieldValue("numberOfWorkersNeeded", rawValue);
                            if (calculateTotalHoursFromWorkers) {
                              calculateTotalHoursFromWorkers(values, rawValue);
                            }
                          }
                        }}
                      />
                    </FilledFormControl>
                  </Box>
                  <Box width={width < 600 ? "100%" : "48%"}>
                    <FilledFormControl>
                      <Field
                        component={TextField}
                        disabled
                        value={(() => {
                          const duration =
                            dayjs(values.endTime).diff(
                              dayjs(values.startTime),
                              "minutes"
                            ) * parseInt(values.numberOfWorkersNeeded);
                          const hours = Math.floor(duration / 60);
                          const mins = duration % 60;
                          return `${hours > 0 ? hours : 0} ${t(
                            "scheduler_hours-label"
                          )} ${mins > 0 ? mins : 0} ${t(
                            "scheduler_minutes-label"
                          )}`;
                        })()}
                        type="text"
                        variant="filled"
                        label={t("scheduler_total-hours")}
                        name="total-hours"
                      />
                    </FilledFormControl>
                  </Box>
                </Box>

                {!isShiftBySkillEnabled ? null : (
                  <Box mt={3} mb={1}>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                        fontFamily: "Roboto",
                      }}
                    >
                      {t("scheduler_shift-type-find-workers")}
                    </Typography>
                    <FormControl
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={shiftType}
                        onChange={(e) => {
                          if (e.target.value === "skills") {
                            setFieldValue("jobId", "");
                            setFieldValue(
                              "shiftSkills",
                              initialValues.shiftSkills
                            );
                          } else {
                            setFieldValue(
                              "jobId",
                              initialValues.jobId ? initialValues.jobId : ""
                            );
                            setFieldValue("shiftSkills", []);
                          }
                          setShiftType(e.target.value);
                        }}
                        sx={{ display: "flex", flexDirection: "row" }}
                      >
                        <FormControlLabel
                          value="jobs"
                          control={<Radio />}
                          label={t("scheduler_job-role")}
                          disabled={values.shiftPublished}
                        />
                        <FormControlLabel
                          value="skills"
                          control={<Radio />}
                          label={t("scheduler_skills")}
                          disabled={values.shiftPublished}
                        />
                      </RadioGroup>
                      {shiftType === "skills" ? (
                        <Tooltip
                          // title='All default skill levels are set in the Admin section'
                          title={t("scheduler_skill-competency-tooltip", {
                            level: levelName,
                          })}
                          arrow
                          slotProps={{
                            popper: {
                              sx: {
                                [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                                  {
                                    width: "150px",
                                  },
                              },
                            },
                          }}
                        >
                          <InfoOutlinedIcon />
                        </Tooltip>
                      ) : null}
                    </FormControl>
                  </Box>
                )}

                {shiftType === "skills" ? (
                  <SelectSkills
                    values={values}
                    setFieldValue={setFieldValue}
                    getNumberOfStaff={getNumberOfStaff}
                    resetMaxWorkersByLocationJob={resetMaxWorkersByLocationJob}
                  />
                ) : (
                  <Box width={"100%"}>
                    <FilledFormControl>
                      <Autocomplete
                        options={filteredJobs ?? []}
                        getOptionLabel={(option) => option.name ?? ""}
                        value={
                          filteredJobs?.find(
                            (job: any) => job.id === values.jobId
                          ) ?? null
                        }
                        disabled={!values.locationId || values.shiftPublished}
                        onChange={(e, newValue) => {
                          if (newValue) {
                            if (getNumberOfStaff) {
                              getNumberOfStaff(
                                newValue?.id.toString() ?? "",
                                values?.locationId,
                                values?.workCenterId,
                                new Date(values.startTime).toISOString(),
                                new Date(values.endTime).toISOString(),
                                [],
                                values.allowPartialSignups,
                                values.allowedWorkerTypeIds
                              );
                            }
                            setFieldValue("jobId", newValue.id ?? "");
                            setFieldValue("hexColor", newValue.hexColor ?? "");
                          } else {
                            setFieldValue("jobId", "");
                            setFieldValue("hexColor", "");
                          }
                        }}
                        renderInput={(params) => {
                          return (
                            <Text
                              {...params}
                              variant="filled"
                              label={t("scheduler_job-role")}
                              disabled={
                                !values.locationId || values.shiftPublished
                              }
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: values.jobId && (
                                  <JobColor
                                    color={`#${
                                      (
                                        filteredJobs?.find(
                                          (job: any) => job.id === values.jobId
                                        ) || { hexColor: "ffffff" }
                                      ).hexColor
                                    }`}
                                  />
                                ),
                              }}
                            />
                          );
                        }}
                        renderOption={(props, option) => (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              gap: "5px",
                            }}
                            component={"li"}
                            {...props}
                            key={`job-${option.id}`}
                          >
                            <JobColor color={`#${option.hexColor}`} />
                            <Typography>{option.name}</Typography>
                          </Box>
                        )}
                      />
                      <Typography
                        variant="caption"
                        sx={{
                          marginTop: "2px",
                          color:
                            maxWorkersByJobLocation.data === 0 ? "red" : "auto",
                        }}
                      >
                        {maxWorkersByJobLocation.status === "pending" ? (
                          <CircularProgress size={20} />
                        ) : maxWorkersByJobLocation.status === "fulfilled" &&
                          values.jobId ? (
                          // " worker(s) have this job"
                          t("scheduler_workers-found", {
                            count: maxWorkersByJobLocation.data,
                          })
                        ) : (
                          ""
                        )}
                      </Typography>
                    </FilledFormControl>
                  </Box>
                )}

                {shiftWorkerTypeFilterEnabled && workerTypes.length > 0 && (
                  <Box width="100%" mt={2}>
                    <Autocomplete
                      multiple
                      disableCloseOnSelect
                      disabled={values.shiftPublished}
                      options={workerTypes}
                      getOptionLabel={(option: any) => option.name}
                      value={
                        values.allowedWorkerTypeIds === null
                          ? workerTypes
                          : workerTypes.filter((wt: any) =>
                              values.allowedWorkerTypeIds?.includes(wt.id)
                            )
                      }
                      onChange={(_: any, selected: any[]) => {
                        const next =
                          selected.length === workerTypes.length
                            ? null
                            : selected.map((wt: any) => wt.id);
                        setFieldValue("allowedWorkerTypeIds", next);
                        if (getNumberOfStaff) {
                          const startTimeISO = new Date(
                            values.startTime
                          ).toISOString();
                          const endTimeISO = new Date(
                            values.endTime
                          ).toISOString();
                          getNumberOfStaff(
                            shiftType === "skills" ? null : values.jobId,
                            values.locationId,
                            values.workCenterId,
                            startTimeISO,
                            endTimeISO,
                            shiftType === "skills" ? values.shiftSkills : [],
                            values.allowPartialSignups,
                            next
                          );
                        }
                      }}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox checked={selected} sx={{ mr: 1 }} />
                          {option.name}
                        </li>
                      )}
                      renderInput={(params) => (
                        <Text
                          {...params}
                          variant="filled"
                          label={t("scheduler_allowed-worker-types")}
                        />
                      )}
                    />
                  </Box>
                )}

                <Box width={"100%"} mr={1} mt={2} mb={2}>
                  <FilledFormControl>
                    <Text
                      type="text"
                      variant="filled"
                      name="note"
                      id="note"
                      label={t("scheduler_note-to-workers")}
                      InputLabelProps={{ shrink: true }}
                      placeholder={t("scheduler_note-placeholder")}
                      multiline
                      rows={2}
                      value={values.shiftNote}
                      disabled={isSubmitting || values.shiftPublished}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setFieldValue("shiftNote", e.target.value);
                      }}
                      error={values.shiftNote.length > 250}
                      helperText={
                        values.shiftNote.length > 250
                          ? t("scheduler_note-max-length")
                          : ""
                      }
                    />
                  </FilledFormControl>
                  <Box display="flex" justifyContent="flex-end">
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "19px",
                        fontFamily: "Roboto",
                        color: "#666666",
                      }}
                    >{`${values.shiftNote.length} / 250`}</Typography>
                  </Box>
                </Box>

                {urgentShiftEnabledLocations?.includes(
                  Number(values.locationId)
                ) && (
                  <Box width="100%" mt={2} mb={2}>
                    <Box display="flex" alignItems="center">
                      <Toggle
                        name="isUrgent"
                        id="isUrgent"
                        checked={values.isUrgent}
                        onChange={() =>
                          setFieldValue("isUrgent", !values.isUrgent)
                        }
                      />
                      <Box display="flex" flexDirection="column" ml={2}>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontFamily: "Roboto",
                            fontWeight: 400,
                            letterSpacing: "0.15px",
                            color: "#000000DE",
                          }}
                        >
                          {t("scheduler_mark-as-urgent")}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontFamily: "Roboto",
                            fontWeight: 400,
                            letterSpacing: "0.4px",
                            color: "#00000099",
                          }}
                        >
                          {t("scheduler_urgent-notifications-info")}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                )}

                {(() => {
                  // Check if partial signups should be disabled
                  const selectedWorkcenter = filterAllWorkcenters?.find(
                    (workcenter: SchedulerWorkCenter) =>
                      workcenter.id === Number(values.workCenterId)
                  );

                  const selectedLocation = filterAllLocations?.find(
                    (location: { id: number }) =>
                      location.id === Number(values.locationId)
                  );

                  const shiftDuration =
                    differenceInMinutes(
                      new Date(values.endTime),
                      new Date(values.startTime)
                    ) / 60;

                  const isPartialSignupVisible =
                    values.workCenterId &&
                    (selectedWorkcenter?.isPartialSignupEnabled ||
                      (selectedWorkcenter as any)?.IsPartialSignupEnabled);

                  const isPartialSignupDisabled =
                    values.shiftPublished || values.isFlexiSignupEnabled;

                  const isFlexiSignupVisible =
                    values.workCenterId &&
                    (selectedWorkcenter?.isFlexiSignupEnabled ||
                      (selectedWorkcenter as any)?.IsFlexiSignupEnabled);

                  const isFlexiSignupDisabled =
                    values.shiftPublished || values.allowPartialSignups;

                  if (!isPartialSignupVisible && !isFlexiSignupVisible)
                    return null;

                  return (
                    <Box width="100%" mt={2}>
                      <Box display="flex" alignItems="center">
                        <Toggle
                          name="allowFlexibleSignups"
                          id="allowFlexibleSignups"
                          checked={
                            values.allowPartialSignups ||
                            values.isFlexiSignupEnabled
                          }
                          onChange={() => {
                            const isCurrentlyEnabled =
                              values.allowPartialSignups ||
                              values.isFlexiSignupEnabled;
                            if (isCurrentlyEnabled) {
                              const newValues = {
                                ...values,
                                allowPartialSignups: false,
                                isFlexiSignupEnabled: false,
                              };
                              setValues(newValues);
                              if (getNumberOfStaff) {
                                getNumberOfStaff(
                                  shiftType === "skills" ? null : values.jobId,
                                  values.locationId,
                                  values.workCenterId,
                                  new Date(values.startTime).toISOString(),
                                  new Date(values.endTime).toISOString(),
                                  shiftType === "skills"
                                    ? values.shiftSkills
                                    : [],
                                  false,
                                  values.allowedWorkerTypeIds
                                );
                              }
                            } else {
                              if (isPartialSignupVisible) {
                                const newValues = {
                                  ...values,
                                  allowPartialSignups: true,
                                  isFlexiSignupEnabled: false,
                                };
                                setValues(newValues);
                                if (getNumberOfStaff) {
                                  getNumberOfStaff(
                                    shiftType === "skills"
                                      ? null
                                      : values.jobId,
                                    values.locationId,
                                    values.workCenterId,
                                    new Date(values.startTime).toISOString(),
                                    new Date(values.endTime).toISOString(),
                                    shiftType === "skills"
                                      ? values.shiftSkills
                                      : [],
                                    true,
                                    values.allowedWorkerTypeIds
                                  );
                                }
                              } else if (isFlexiSignupVisible) {
                                setValues({
                                  ...values,
                                  allowPartialSignups: false,
                                  isFlexiSignupEnabled: true,
                                  minFlexiSignupHours: Math.max(
                                    values.minFlexiSignupHours || 0,
                                    1
                                  ),
                                });
                              }
                            }
                            setTimeout(() => validateForm(), 0);
                          }}
                          disabled={values.shiftPublished}
                        />
                        <Box display="flex" flexDirection="column" ml={2}>
                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontFamily: "Roboto",
                              fontWeight: 400,
                              letterSpacing: "0.15px",
                              color: values.shiftPublished
                                ? "#bdbdbd"
                                : "#000000DE",
                            }}
                          >
                            {t("scheduler_allow-flexible-signups")}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontFamily: "Roboto",
                              fontWeight: 400,
                              letterSpacing: "0.4px",
                              color: values.shiftPublished
                                ? "#bdbdbd"
                                : "#00000099",
                            }}
                          >
                            {t("scheduler_flexible-signups-desc")}
                          </Typography>
                        </Box>
                      </Box>

                      {(values.allowPartialSignups ||
                        values.isFlexiSignupEnabled) && (
                        <Box mt={2} ml={1}>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontFamily: "Roboto",
                              fontWeight: 500,
                              color: "#000000DE",
                              mb: 1,
                            }}
                          >
                            {t("scheduler_signup-flexibility")}
                          </Typography>

                          {isPartialSignupVisible && isFlexiSignupVisible ? (
                            <RadioGroup
                              value={
                                values.allowPartialSignups ? "half" : "custom"
                              }
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val === "half") {
                                  const newValues = {
                                    ...values,
                                    allowPartialSignups: true,
                                    isFlexiSignupEnabled: false,
                                  };
                                  setValues(newValues);
                                  if (getNumberOfStaff) {
                                    getNumberOfStaff(
                                      shiftType === "skills"
                                        ? null
                                        : values.jobId,
                                      values.locationId,
                                      values.workCenterId,
                                      new Date(values.startTime).toISOString(),
                                      new Date(values.endTime).toISOString(),
                                      shiftType === "skills"
                                        ? values.shiftSkills
                                        : [],
                                      true,
                                      values.allowedWorkerTypeIds
                                    );
                                  }
                                } else {
                                  const newValues = {
                                    ...values,
                                    allowPartialSignups: false,
                                    isFlexiSignupEnabled: true,
                                    minFlexiSignupHours: Math.max(
                                      values.minFlexiSignupHours || 0,
                                      1
                                    ),
                                  };
                                  setValues(newValues);
                                  if (getNumberOfStaff) {
                                    getNumberOfStaff(
                                      shiftType === "skills"
                                        ? null
                                        : values.jobId,
                                      values.locationId,
                                      values.workCenterId,
                                      new Date(values.startTime).toISOString(),
                                      new Date(values.endTime).toISOString(),
                                      shiftType === "skills"
                                        ? values.shiftSkills
                                        : [],
                                      false,
                                      values.allowedWorkerTypeIds
                                    );
                                  }
                                }
                                setTimeout(() => validateForm(), 0);
                              }}
                            >
                              <Box
                                sx={{
                                  border: "1px solid #E0E0E0",
                                  borderRadius: "8px",
                                  p: 1.5,
                                  mb: 1,
                                  backgroundColor: values.allowPartialSignups
                                    ? "#F4F7FE"
                                    : "transparent",
                                }}
                              >
                                <FormControlLabel
                                  value="half"
                                  control={
                                    <Radio
                                      size="small"
                                      disabled={
                                        values.shiftPublished ||
                                        shiftDuration <
                                          (selectedLocation?.partialShiftMinHours ??
                                            0)
                                      }
                                    />
                                  }
                                  label={
                                    <Box>
                                      <Typography
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: 500,
                                          color:
                                            values.shiftPublished ||
                                            shiftDuration <
                                              (selectedLocation?.partialShiftMinHours ??
                                                0)
                                              ? "#bdbdbd"
                                              : "#000000DE",
                                        }}
                                      >
                                        {t("scheduler_half-shift-min-duration", {
                                          count:
                                            selectedLocation?.partialShiftMinHours ??
                                            0,
                                          unit:
                                            (selectedLocation?.partialShiftMinHours ??
                                              0) !== 1
                                              ? t("scheduler_hours-unit")
                                              : t("scheduler_hour-unit"),
                                        })}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          fontSize: "12px",
                                          color:
                                            values.shiftPublished ||
                                            shiftDuration <
                                              (selectedLocation?.partialShiftMinHours ??
                                                0)
                                              ? "#bdbdbd"
                                              : "#00000099",
                                        }}
                                      >
                                        {t("scheduler_half-shift-desc")}
                                      </Typography>
                                      <Box display="flex" gap={1} mt={1}>
                                        <Box
                                          sx={{
                                            px: 1,
                                            py: 0.5,
                                            bgcolor: "#E0E0E0",
                                            borderRadius: "4px",
                                            fontSize: "10px",
                                            fontWeight: 700,
                                            color:
                                              values.shiftPublished ||
                                              shiftDuration <
                                                (selectedLocation?.partialShiftMinHours ??
                                                  0)
                                                ? "#bdbdbd"
                                                : "inherit",
                                          }}
                                        >
                                          {t("scheduler_first-half")}
                                        </Box>
                                        <Box
                                          sx={{
                                            px: 1,
                                            py: 0.5,
                                            bgcolor: "#E0E0E0",
                                            borderRadius: "4px",
                                            fontSize: "10px",
                                            fontWeight: 700,
                                            color:
                                              values.shiftPublished ||
                                              shiftDuration <
                                                (selectedLocation?.partialShiftMinHours ??
                                                  0)
                                                ? "#bdbdbd"
                                                : "inherit",
                                          }}
                                        >
                                          {t("scheduler_second-half")}
                                        </Box>
                                      </Box>
                                    </Box>
                                  }
                                  sx={{ alignItems: "flex-start", m: 0 }}
                                />
                              </Box>

                              <Box
                                sx={{
                                  border: "1px solid #E0E0E0",
                                  borderRadius: "8px",
                                  p: 1.5,
                                  mb: 1,
                                  backgroundColor: values.isFlexiSignupEnabled
                                    ? "#F4F7FE"
                                    : "transparent",
                                }}
                              >
                                <FormControlLabel
                                  value="custom"
                                  control={
                                    <Radio
                                      size="small"
                                      disabled={
                                        values.shiftPublished ||
                                        shiftDuration <
                                          (selectedLocation?.flexiShiftMinHours ??
                                            1)
                                      }
                                    />
                                  }
                                  label={
                                    <Box width="100%">
                                      <Typography
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: 500,
                                          color:
                                            values.shiftPublished ||
                                            shiftDuration <
                                              (selectedLocation?.flexiShiftMinHours ??
                                                1)
                                              ? "#bdbdbd"
                                              : "#000000DE",
                                        }}
                                      >
                                        {t(
                                          "scheduler_custom-duration-min-duration",
                                          {
                                            count:
                                              selectedLocation?.flexiShiftMinHours ??
                                              1,
                                            unit:
                                              (selectedLocation?.flexiShiftMinHours ??
                                                1) > 1
                                                ? t("scheduler_hours-unit")
                                                : t("scheduler_hour-unit"),
                                          }
                                        )}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          fontSize: "12px",
                                          color:
                                            values.shiftPublished ||
                                            shiftDuration <
                                              (selectedLocation?.flexiShiftMinHours ??
                                                1)
                                              ? "#bdbdbd"
                                              : "#00000099",
                                        }}
                                      >
                                        {t("scheduler_custom-duration-desc")}
                                      </Typography>
                                      {values.isFlexiSignupEnabled && (
                                        <Box mt={2} width="100%">
                                          <FilledFormControl
                                            customStyles={{
                                              width: "260px",
                                              minWidth: "260px",
                                              maxWidth: "260px",
                                            }}
                                          >
                                            <Field
                                              component={TextField}
                                              type="number"
                                              variant="filled"
                                              name="minFlexiSignupHours"
                                              label={t(
                                                "scheduler_minimum-signup-duration"
                                              )}
                                              onKeyDown={(e) => {
                                                if (
                                                  [
                                                    "e",
                                                    "E",
                                                    "+",
                                                    "-",
                                                    ".",
                                                    ",",
                                                  ].includes(e.key)
                                                ) {
                                                  e.preventDefault();
                                                }
                                              }}
                                              disabled={
                                                values.shiftPublished ||
                                                shiftDuration <
                                                  (selectedLocation?.flexiShiftMinHours ??
                                                    1)
                                              }
                                              InputProps={{
                                                startAdornment: (
                                                  <InputAdornment
                                                    position="start"
                                                    sx={{
                                                      mt: "16px !important",
                                                    }}
                                                  >
                                                    <IconButton
                                                      size="small"
                                                      disabled={
                                                        values.shiftPublished ||
                                                        values.minFlexiSignupHours <=
                                                          1
                                                      }
                                                      onClick={() => {
                                                        const minHours = 1;
                                                        const currentValue =
                                                          values.minFlexiSignupHours ||
                                                          minHours;
                                                        setFieldValue(
                                                          "minFlexiSignupHours",
                                                          Math.max(
                                                            minHours,
                                                            currentValue - 1
                                                          )
                                                        );
                                                      }}
                                                    >
                                                      <RemoveIcon />
                                                    </IconButton>
                                                  </InputAdornment>
                                                ),
                                                endAdornment: (
                                                  <InputAdornment
                                                    position="end"
                                                    sx={{
                                                      mt: "16px !important",
                                                    }}
                                                  >
                                                    <Box
                                                      display="flex"
                                                      alignItems="center"
                                                    >
                                                      <Typography
                                                        sx={{
                                                          mr: 1,
                                                          fontSize: "14px",
                                                          color:
                                                            values.shiftPublished ||
                                                            shiftDuration <
                                                              (selectedLocation?.flexiShiftMinHours ??
                                                                1)
                                                              ? "#bdbdbd"
                                                              : "inherit",
                                                        }}
                                                      >
                                                        {t(
                                                          values.minFlexiSignupHours >
                                                            1
                                                            ? "scheduler_hours-unit"
                                                            : "scheduler_hour-unit"
                                                        )}
                                                      </Typography>
                                                      <IconButton
                                                        size="small"
                                                        disabled={
                                                          values.shiftPublished ||
                                                          values.minFlexiSignupHours +
                                                            1 >=
                                                            shiftDuration
                                                        }
                                                        onClick={() => {
                                                          const currentValue =
                                                            values.minFlexiSignupHours ||
                                                            1;
                                                          setFieldValue(
                                                            "minFlexiSignupHours",
                                                            currentValue + 1
                                                          );
                                                        }}
                                                      >
                                                        <AddIcon />
                                                      </IconButton>
                                                    </Box>
                                                  </InputAdornment>
                                                ),
                                              }}
                                              inputProps={{
                                                step: 1,
                                                min: 1,
                                                style: { textAlign: "center" },
                                              }}
                                              disabled={values.shiftPublished}
                                              value={values.minFlexiSignupHours}
                                              helperText={
                                                errors.minFlexiSignupHours
                                              }
                                              error={
                                                !!errors.minFlexiSignupHours
                                              }
                                            />
                                          </FilledFormControl>
                                        </Box>
                                      )}
                                    </Box>
                                  }
                                  sx={{
                                    alignItems: "flex-start",
                                    m: 0,
                                    width: "100%",
                                  }}
                                />
                              </Box>
                            </RadioGroup>
                          ) : (
                            <Box
                              sx={{
                                border: "1px solid #E0E0E0",
                                borderRadius: "8px",
                                p: 1.5,
                                backgroundColor: "#F4F7FE",
                              }}
                            >
                              {isPartialSignupVisible ? (
                                <Box>
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      color:
                                        values.shiftPublished ||
                                        shiftDuration <
                                          (selectedLocation?.partialShiftMinHours ??
                                            0)
                                          ? "#bdbdbd"
                                          : "#000000DE",
                                    }}
                                  >
                                    {t("scheduler_half-shift-min-duration", {
                                      count:
                                        selectedLocation?.partialShiftMinHours ??
                                        0,
                                      unit:
                                        (selectedLocation?.partialShiftMinHours ??
                                          0) !== 1
                                          ? t("scheduler_hours-unit")
                                          : t("scheduler_hour-unit"),
                                    })}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      color:
                                        values.shiftPublished ||
                                        shiftDuration <
                                          (selectedLocation?.partialShiftMinHours ??
                                            0)
                                          ? "#bdbdbd"
                                          : "#00000099",
                                    }}
                                  >
                                    {t("scheduler_half-shift-desc")}
                                  </Typography>
                                  <Box display="flex" gap={1} mt={1}>
                                    <Box
                                      sx={{
                                        px: 1,
                                        py: 0.5,
                                        bgcolor: "#E0E0E0",
                                        borderRadius: "4px",
                                        fontSize: "10px",
                                        fontWeight: 700,
                                        color:
                                          values.shiftPublished ||
                                          shiftDuration <
                                            (selectedLocation?.partialShiftMinHours ??
                                              0)
                                            ? "#bdbdbd"
                                            : "inherit",
                                      }}
                                    >
                                      {t("scheduler_first-half")}
                                    </Box>
                                    <Box
                                      sx={{
                                        px: 1,
                                        py: 0.5,
                                        bgcolor: "#E0E0E0",
                                        borderRadius: "4px",
                                        fontSize: "10px",
                                        fontWeight: 700,
                                        color:
                                          values.shiftPublished ||
                                          shiftDuration <
                                            (selectedLocation?.partialShiftMinHours ??
                                              0)
                                            ? "#bdbdbd"
                                            : "inherit",
                                      }}
                                    >
                                      {t("scheduler_second-half")}
                                    </Box>
                                  </Box>
                                </Box>
                              ) : (
                                <Box width="100%">
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      color:
                                        values.shiftPublished ||
                                        shiftDuration <
                                          (selectedLocation?.flexiShiftMinHours ??
                                            1)
                                          ? "#bdbdbd"
                                          : "#000000DE",
                                    }}
                                  >
                                    {t("scheduler_custom-duration-min-duration", {
                                      count:
                                        selectedLocation?.flexiShiftMinHours ?? 1,
                                      unit:
                                        (selectedLocation?.flexiShiftMinHours ??
                                          1) > 1
                                          ? t("scheduler_hours-unit")
                                          : t("scheduler_hour-unit"),
                                    })}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      color:
                                        values.shiftPublished ||
                                        shiftDuration <
                                          (selectedLocation?.flexiShiftMinHours ??
                                            1)
                                          ? "#bdbdbd"
                                          : "#00000099",
                                    }}
                                  >
                                    {t("scheduler_custom-duration-desc")}
                                  </Typography>
                                  <Box mt={2} width="100%">
                                    <FilledFormControl
                                      customStyles={{
                                        width: "260px",
                                        minWidth: "260px",
                                        maxWidth: "260px",
                                      }}
                                    >
                                      <Field
                                        component={TextField}
                                        type="number"
                                        variant="filled"
                                        name="minFlexiSignupHours"
                                        label={t(
                                          "scheduler_minimum-signup-duration"
                                        )}
                                        onKeyDown={(e) => {
                                          if (
                                            [
                                              "e",
                                              "E",
                                              "+",
                                              "-",
                                              ".",
                                              ",",
                                            ].includes(e.key)
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                        disabled={
                                          values.shiftPublished ||
                                          shiftDuration <
                                            (selectedLocation?.flexiShiftMinHours ??
                                              1)
                                        }
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment
                                              position="start"
                                              sx={{ mt: "16px !important" }}
                                            >
                                              <IconButton
                                                size="small"
                                                disabled={
                                                  values.shiftPublished ||
                                                  shiftDuration <
                                                    (selectedLocation?.flexiShiftMinHours ??
                                                      1) ||
                                                  values.minFlexiSignupHours <=
                                                    1
                                                }
                                                onClick={() => {
                                                  const minHours = 1;
                                                  const currentValue =
                                                    values.minFlexiSignupHours ||
                                                    minHours;
                                                  setFieldValue(
                                                    "minFlexiSignupHours",
                                                    Math.max(
                                                      minHours,
                                                      currentValue - 1
                                                    )
                                                  );
                                                }}
                                              >
                                                <RemoveIcon />
                                              </IconButton>
                                            </InputAdornment>
                                          ),
                                          endAdornment: (
                                            <InputAdornment
                                              position="end"
                                              sx={{ mt: "16px !important" }}
                                            >
                                              <Box
                                                display="flex"
                                                alignItems="center"
                                              >
                                                <Typography
                                                  sx={{
                                                    mr: 1,
                                                    fontSize: "14px",
                                                    color:
                                                      values.shiftPublished ||
                                                      shiftDuration <
                                                        (selectedLocation?.flexiShiftMinHours ??
                                                          1)
                                                        ? "#bdbdbd"
                                                        : "inherit",
                                                  }}
                                                >
                                                  {t(
                                                    values.minFlexiSignupHours > 1
                                                      ? "scheduler_hours-unit"
                                                      : "scheduler_hour-unit"
                                                  )}
                                                </Typography>
                                                <IconButton
                                                  size="small"
                                                  disabled={
                                                    values.shiftPublished ||
                                                    shiftDuration <
                                                      (selectedLocation?.flexiShiftMinHours ??
                                                        1) ||
                                                    values.minFlexiSignupHours +
                                                      1 >=
                                                      shiftDuration
                                                  }
                                                  onClick={() => {
                                                    const currentValue =
                                                      values.minFlexiSignupHours ||
                                                      1;
                                                    setFieldValue(
                                                      "minFlexiSignupHours",
                                                      currentValue + 1
                                                    );
                                                  }}
                                                >
                                                  <AddIcon />
                                                </IconButton>
                                              </Box>
                                            </InputAdornment>
                                          ),
                                        }}
                                        inputProps={{
                                          step: 1,
                                          min: 1,
                                          style: { textAlign: "center" },
                                        }}
                                        disabled={values.shiftPublished}
                                        value={values.minFlexiSignupHours}
                                        helperText={errors.minFlexiSignupHours}
                                        error={!!errors.minFlexiSignupHours}
                                      />
                                    </FilledFormControl>
                                  </Box>
                                </Box>
                              )}
                            </Box>
                          )}
                        </Box>
                      )}
                    </Box>
                  );
                })()}

              {(() => {
                const selectedWorkcenter = filterAllWorkcenters?.find(
                  (workcenter: SchedulerWorkCenter) =>
                    workcenter.id === Number(values.workCenterId)
                );

                const selectedLocation = filterAllLocations?.find(
                  (location: { id: number }) =>
                    location.id === Number(values.locationId)
                );

                // Gated on the Work Center flag like the create dialog, but a
                // Shift that already carries an override keeps the row so the
                // supervisor can still see and turn off what is in force.
                if (
                  !selectedWorkcenter?.isShiftAcceptanceCutoffEnabled &&
                  !values.isShiftAcceptanceCutoffEnabled
                ) {
                  return null;
                }

                const inheritedCutoffHours = selectedWorkcenter?.isShiftAcceptanceCutoffEnabled
                  ? selectedLocation?.shiftAcceptanceCutoffMinHours ?? null
                  : null;

                const cutoffHours =
                  values.minHoursBeforeShiftStartToAccept ||
                  inheritedCutoffHours ||
                  DEFAULT_CUTOFF_HOURS;

                const acceptUntil = values.isShiftAcceptanceCutoffEnabled
                  ? getAcceptanceCutoffTime(values.startTime, cutoffHours)
                  : null;

                // NOTE: deliberately NOT gated on values.shiftPublished. The
                // cutoff stays editable after publish, right up until the Shift
                // starts, unlike every other field in this dialog.
                return (
                  <Box width="100%" mt={2}>
                    <Box display="flex" alignItems="flex-start">
                      <Toggle
                        name="isShiftAcceptanceCutoffEnabled"
                        id="isShiftAcceptanceCutoffEnabled"
                        checked={values.isShiftAcceptanceCutoffEnabled}
                        onChange={() => {
                          const enabling =
                            !values.isShiftAcceptanceCutoffEnabled;
                          setValues({
                            ...values,
                            isShiftAcceptanceCutoffEnabled: enabling,
                            minHoursBeforeShiftStartToAccept: enabling
                              ? values.minHoursBeforeShiftStartToAccept ||
                                inheritedCutoffHours ||
                                DEFAULT_CUTOFF_HOURS
                              : values.minHoursBeforeShiftStartToAccept,
                          });
                          setTimeout(() => validateForm(), 0);
                        }}
                      />
                      <Box display="flex" flexDirection="column" ml={2}>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontFamily: "Roboto",
                            fontWeight: 400,
                            letterSpacing: "0.15px",
                            color: "#000000DE",
                          }}
                        >
                          {t("scheduler_acceptance-cutoff")}
                        </Typography>
                      </Box>
                    </Box>

                    {values.isShiftAcceptanceCutoffEnabled ? (
                      <Box
                        ml={6}
                        mt={2}
                        sx={{
                          backgroundColor: "#F4F7FE",
                          border: "1px solid #E0E0E0",
                          borderRadius: "8px",
                          p: 1.5,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "#000000DE",
                          }}
                        >
                          {t("scheduler_acceptance-cutoff-label")}
                        </Typography>
                        <Box mt={1}>
                          <CutoffHoursInput
                            value={cutoffHours}
                            onChange={(hours) =>
                              setFieldValue("minHoursBeforeShiftStartToAccept", hours)
                            }
                          />
                        </Box>
                        <Typography
                          sx={{ fontSize: "12px", color: "#00000099", mt: 1 }}
                        >
                          {t("scheduler_acceptance-cutoff-hint")}
                        </Typography>
                        {acceptUntil ? (
                          <Box
                            display="flex"
                            alignItems="center"
                            gap={0.5}
                            mt={1}
                          >
                            <EventAvailableOutlinedIcon
                              sx={{ fontSize: "16px", color: "#0000008f" }}
                            />
                            <Typography
                              sx={{ fontSize: "14px", color: "#000000DE" }}
                            >
                              {t("scheduler_acceptance-cutoff-until", {
                                time: format(acceptUntil, "h:mm a, EEE MMM d", {
                                  locale: dateLocale,
                                }),
                              })}
                            </Typography>
                          </Box>
                        ) : null}
                        {inheritedCutoffHours &&
                        cutoffHours !== inheritedCutoffHours ? (
                          <Typography
                            sx={{ fontSize: "12px", color: "#00000099", mt: 1 }}
                          >
                            {t("scheduler_acceptance-cutoff-override", {
                              hhmm: formatCutoffHours(inheritedCutoffHours),
                            })}
                          </Typography>
                        ) : null}
                      </Box>
                    ) : inheritedCutoffHours ? (
                      <Box
                        ml={6}
                        mt={2}
                        display="flex"
                        gap={1}
                        sx={{
                          border: "1px solid #E0E0E0",
                          borderRadius: "8px",
                          p: 1.5,
                        }}
                      >
                        <TimerOutlinedIcon
                          sx={{ fontSize: "18px", color: "rgba(0,0,0,0.56)" }}
                        />
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 500,
                              color: "rgba(0,0,0,0.87)",
                            }}
                          >
                            {t("scheduler_acceptance-cutoff-opted-out", {
                              hhmm: formatCutoffHours(inheritedCutoffHours),
                            })}
                          </Typography>
                          <Typography
                            sx={{ fontSize: "12px", color: "rgba(0,0,0,0.6)" }}
                          >
                            {t("scheduler_acceptance-cutoff-inherited-none")}
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <Typography
                        ml={6}
                        mt={1}
                        sx={{ fontSize: "12px", color: "rgba(0,0,0,0.6)" }}
                      >
                        {t("scheduler_acceptance-cutoff-inherited-none")}
                      </Typography>
                    )}
                  </Box>
                );
              })()}
              </Box>
              {/* Edit Button */}
              <Box
                sx={{
                  borderTop: "1px solid #E0E0E0",
                  padding: "20px 45px",
                  backgroundColor: "#fff",
                  position: "sticky",
                  bottom: 0,
                  zIndex: 1100,
                }}
              >
                <EditActionButtons
                  handleClose={handleClose}
                  isValid={isValid}
                  dirty={dirty}
                  isSubmitting={isSubmitting}
                  createdByName={values.createdByName}
                  createdBy={values.createdBy}
                  createdDate={values.createdDate}
                  isDisabled={
                    (shiftType === "skills"
                      ? values.shiftSkills.length === 0
                      : values.jobId === "" || values.jobId === undefined) ||
                    (values.shiftPurposeId === 0 && isShiftPurposeEnabled) ||
                    (isShiftPurposeEnabled &&
                      !!shiftPurposeDetailField?.isRequired &&
                      !values.shiftPurposeDetail?.trim())
                  }
                />
              </Box>
            </Form>
          );
        }}
      </Formik>
      {editDraftShiftStatus === "error" && (
        <Snackbar
          open={editDraftShiftStatus === "error"}
          autoHideDuration={1000}
          onClose={() => {
            try {
              dispatch(resetEditDraftShift());
            } catch (e) {
              // Do nothing
            }
          }}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <MuiAlert elevation={6} variant="filled" severity="error">
            {editDraftShiftErrorMessage}
          </MuiAlert>
        </Snackbar>
      )}
    </Box>
  );
};

export default EditShiftDialogForm;
